export const TooltipController = () => {

  $('.tooltip-btn').on('click', (e) => {
    e.preventDefault();
    const $parent = $(e.currentTarget).closest('.tooltip');

    $parent.toggleClass('show');
  })
}



// WEBPACK FOOTER //
// ./src/js/controllers/TooltipController.js